import flowMixin from '@/modules/Flow/mixins/flowMixin'

/**
 * @module
 * @name Timedout
 */
export default {
  name: 'Timedout',
  mixins: [flowMixin],
  mounted() {
    //Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    localStorage.clear()
    sessionStorage.clear()
  }
}
